import * as React from "react";
import { SVGProps } from "react";

const GnosisGno = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 428 428" {...props}>
    <path
      fill="#00193c"
      d="M125.8 243.7c12.3 0 24.3-4.1 34-11.6l-78-78c-18.8 24.3-14.3 59.3 10 78.1 9.8 7.4 21.7 11.5 34 11.5zm232-55.7c0-12.3-4.1-24.3-11.6-34l-78 78c24.3 18.8 59.2 14.3 78-10 7.5-9.7 11.6-21.7 11.6-34z"
    />
    <path
      fill="#00193c"
      d="m397.1 103.1-34.5 34.5c27.8 33.3 23.4 82.9-9.9 110.7-29.2 24.4-71.6 24.4-100.8 0L214 286.2l-37.8-37.8c-33.3 27.8-82.9 23.4-110.7-9.9-24.4-29.2-24.4-71.6 0-100.8L47.8 120 31 103.1C10.7 136.5 0 174.9 0 214c0 118.2 95.8 214 214 214s214-95.8 214-214c.1-39.1-10.7-77.5-30.9-110.9z"
    />
    <path
      fill="#00193c"
      d="M368.8 66.3c-81.5-85.5-216.9-88.7-302.4-7.2-2.5 2.4-4.9 4.8-7.2 7.2-5.3 5.6-10.3 11.4-15 17.5L214 253.7 383.8 83.8c-4.6-6.1-9.7-11.9-15-17.5zM214 28c50 0 96.6 19.3 131.6 54.5L214 214.1 82.4 82.5C117.4 47.3 164 28 214 28z"
    />
  </svg>
);

export default GnosisGno;
